import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FiltersService, CompaniesService } from '@app/_services';
import { PageCategoryService } from '@app/_services/page-category.service';
import { Subject } from 'rxjs';
import { Link } from '@app/_interfaces/link';
import { Products } from '@app/_models';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Pagination } from '@app/_interfaces/pagination.interface';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { RootService } from '@app/_services/root.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { ShopSidebarService } from '@app/_services/shop-sidebar.service';
import { SharedService } from '@app/_services/shared.service';
import { ProductsViewComponent } from '../../_components/products-view/products-view.component';
import { ShopSidebarComponent } from '../../_components/shop-sidebar/shop-sidebar.component';
import { WidgetAdvancedSearchComponent } from '../widget-advanced-search/widget-advanced-search.component';
import { NgIf } from '@angular/common';
import { WidgetFiltersComponent } from '@app/widgets/widget-filters/widget-filters.component';
@UntilDestroy()
@Component({
  selector: 'app-block-company-products',
  templateUrl: './block-company-products.component.html',
  styleUrls: ['./block-company-products.component.scss'],
  providers: [
    { provide: ShopSidebarService, useClass: ShopSidebarService },
  ],
  standalone: true,
  imports: [NgIf, WidgetAdvancedSearchComponent, ShopSidebarComponent, ProductsViewComponent, WidgetFiltersComponent]
})
export class BlockCompanyProductsComponent implements OnInit {

  @Input() options: any = {};
  @Input() showSidebar = 'true';
  @Input() view = 'default';

  destroy$: Subject<void> = new Subject<void>();

  columns: 3 | 4 | 5 = 3;
  viewMode: 'grid' | 'grid-with-features' | 'list' = 'grid';
  sidebarPosition: 'start' | 'end' = 'start'; // For LTR scripts "start" is "left" and "end" is "right"
  breadcrumbs: Link[] = [];
  pageHeader: string;
  image = 'assets/images/nologo.png'
  offcanvas: 'always' | 'mobile' = 'always';

  products: Products[];
  categoryData: any;
  companyData: any;
  bsModalRef: BsModalRef;
  params: Pagination = {
    page: 1,
    limit: this.sharedService.paginations.limit,
  }
  productsCount;
  filterParams;
  companySlug;
  filtersData;
  userId;
  isSubcategories = false;
  layout;
  blocks = [];
  subcategories;
  advancedSearch;

  constructor(

    private cdr: ChangeDetectorRef,
    private root: RootService,
    private route: ActivatedRoute,
    private pageService: PageCategoryService,
    private filtersService: FiltersService,
    private companiesService: CompaniesService,
    private modalService: BsModalService,
    private sharedService: SharedService,

  ) {
    this.filtersData = [];
    this.route.data.pipe(untilDestroyed(this)).subscribe(data => {
      this.breadcrumbs = [
        { label: 'Home', url: this.root.home() },
        { label: 'Shop', url: this.root.shop() },
      ];

      this.companyData = data?.company?.company;
      this.advancedSearch = data?.company?.advancedSearchBlock;
      this.layout = this.companyData?.layout;
      this.filtersService.filters$.subscribe(data => {
        this.pageService.setIsLoading(false);
      })

      this.pageService.setList(data.products);
      this.columns = 'columns' in data ? data.columns : this.columns;
      this.viewMode = 'viewMode' in data ? data.viewMode : this.viewMode;
      this.sidebarPosition = 'sidebarPosition' in data ? data.sidebarPosition : this.sidebarPosition;
      
      this.products = data?.company?.products;
      this.productsCount = data?.company?.filters?.count;
      this.categoryData = data?.company?.categories;
      this.filtersData = data?.company?.filters?.filters;      
      this.filtersService.setFiltersDataEvent({ filtersData: this.filtersData || [], category: this.categoryData || {}, isCompany: true });
      this.pageService.setIsLoading(false);

      if (_.isArray(this.categoryData)) {
        this.subcategories = {
          parent: false,
          items: this.categoryData
        }
      } else {
        this.subcategories = {
          parent: this.categoryData,
          items: this.categoryData?.subCategories
        }
      }
    });

    this.sharedService.advancedSearch$.pipe(untilDestroyed(this)).subscribe(advancedSearch => {
      if (!_.isEmpty(advancedSearch))
        this.advancedSearch = advancedSearch;
      else
        this.advancedSearch = false;
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.advancedSearch = false;
    this.sharedService.advancedSearchSubject$.next({});

  }

  getCompanySlug(): string | null {
    return this.route.snapshot.params.slug || this.route.snapshot.data.CompanySlug || null;
  }

  imagebObjectKey(imageObject) {
    return _.findKey(imageObject);
  }

  /* askVendor() {
    const initialState = {
        companyId: this.companyData._id
    };
    this.bsModalRef = this.modalService.show(AskVendorComponent, { initialState });
    this.bsModalRef.content.closeBtnName = 'Close';
  } */

  stopLoading() {
    this.pageService.setIsLoading(false);
  }

  ngOnInit(): void {

  }

}
